import React, { useState, useEffect } from "react";
import axios from "axios";
import { useAlert } from "../context/AlertContext";
import "../css/Usuario.css";

function Usuario({ setIsLoggedIn }) {
  const [userSession, setUserSession] = useState(localStorage.getItem('userSession'));
  const URL_API = process.env.REACT_APP_URL_API || 'http://localhost:5000';
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [usuarios, setUsuarios] = useState([]);
  const [formData, setFormData] = useState({
    id: null,
    nombre: "",
    apellido_paterno: "",
    apellido_materno: "",
    correo: "",
    matricula: "",
    tipo: 0,
    contraseña: "",
  });
  const [isEditing, setIsEditing] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { showAlert } = useAlert();

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  // Función para cargar los usuarios
  useEffect(() => {
    setUserSession(localStorage.getItem('userSession'));
    fetchUsuarios();
  }, []);

  const fetchUsuarios = async () => {
    try {
      const response = await axios.post(URL_API+"crudUsuario/getUsuario", { correo: userSession });

      if (response.data.success) {
        setUsuarios(response.data.results);
      } else {

        showAlert(response.data.message, "error");
        localStorage.removeItem("userSession");
        localStorage.removeItem("tipoSession");
        localStorage.removeItem("tokenSession");

        setTimeout(() => {
          setIsLoggedIn(false);
        }, 1000);
      }
    } catch (error) {
      showAlert("Error al conectarse con el servidor", "error");
    }
  };

  const handleClose = () => {
    setFormData({
      id: null,
      nombre: "",
      apellido_paterno: "",
      apellido_materno: "",
      correo: "",
      matricula: "",
      tipo: 0,
      contraseña: "",
    });
    setErrors({});
    setIsModalOpen(false);
  }

  //Validación
  const validate = () => {
    const newErrors = {};

    for (const key in formData) {
      if (key !== "tipo" && key !== "id") {
        if (!formData[key].trim()) {
          newErrors[key] = `Este campo es obligatorio`;
        }
      }
    }

    const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    if (formData.correo && !emailRegex.test(formData.correo)) {
      newErrors.correo = "El correo no es válido";
    }

    if (formData.matricula.length < 10) {
      newErrors.matricula = "La matrícula debe contener 10 carácteres";
    }

    if (!/^\d{10}$/.test(formData.matricula)) {
      newErrors.matricula = "La matrícula debe contener exactamente 10 dígitos numéricos";
    }

    if (!isEditing) {
      const passwordRegex = /^(?=.*[!@#$%^&*])(?=.{6,})/;
      if (formData.contraseña && !passwordRegex.test(formData.contraseña)) {
        newErrors.contraseña = "La contraseña debe tener al menos 6 caracteres y al menos un carácter especial";
      }

      if (formData.contraseña !== formData.confirmarContraseña) {
        newErrors.confirmarContraseña = "Las contraseñas no coinciden";
      }
    }

    return newErrors;
  };

  // Funciones CRUD
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value || "" });
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: ""
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const requestData = {
      ...formData,
      correo: formData.correo || "",
    };

    try {
      if (isEditing) {
        if (!formData.id) {
          setErrors((errors) => ({
            ...errors,
            error: "No hay un ID válido"
          }));
          return;
        }
        const response = await axios.put(URL_API+`crudUsuario/usuario/${formData.id}`, requestData);

        if (response.data.success) {
          setErrors((errors) => ({
            ...errors,
            error: response.data.message
          }));
          setIsEditing(false);
        } else {
          const campo = response.data.campo;
          setErrors((errors) => ({
            ...errors,
            [campo]: response.data.message
          }));
          return;
        }
      } else {
        const response = await axios.post(URL_API+"crudUsuario/usuario", requestData);

        if (!response.data.success) {
          const campo = response.data.campo;
          setErrors((errors) => ({
            ...errors,
            [campo]: response.data.message
          }));
          return;
        }
      }

      fetchUsuarios();
      handleClose();
    } catch (error) {
      setErrors((errors) => ({
        ...errors,
        error: "Error con el servidor"
      }));
    }
  };

  const handleEdit = (usuario) => {
    setFormData({
      id: usuario.id || null,
      nombre: usuario.nombre || "",
      apellido_paterno: usuario.apellido_paterno || "",
      apellido_materno: usuario.apellido_materno || "",
      correo: usuario.correo || "",
      matricula: usuario.matricula || "",
      tipo: usuario.tipo || 0,
    });
    setIsEditing(true);
    setIsModalOpen(true);
  };

  const handleDelete = async (id, tipo) => {
    try {
      const response = await axios.put(URL_API+`crudUsuario/usuarioDelete/${id}`, { tipo: tipo });

      if (response.data.success) {
        showAlert(response.data.message, "success");
        fetchUsuarios();
      }
    } catch (error) {
      showAlert("Error con el servidor", "error");
    }
  };

  return (
    <div className="container">
      <h1>Gestión de Usuarios</h1>

      {/* Botón "Nuevo Usuario" */}
      <button
        onClick={() => setIsModalOpen(true)}
        className="nuevo-usuario-btn"
      >
        Nuevo Usuario
      </button>

      {/* Modal con el formulario */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={() => handleClose()}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h2>{isEditing ? "Editar Usuario" : "Agregar Nuevo Usuario"}</h2>
            <form onSubmit={handleSubmit} className="form">
              <div className="input-group">
                <label>Nombre</label>
                <input
                  type="text"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                />
                {errors.nombre && <p className="error-message">{errors.nombre}</p>}
              </div>
              <div className="input-group">
                <label>Apellido Paterno</label>
                <input
                  type="text"
                  name="apellido_paterno"
                  value={formData.apellido_paterno}
                  onChange={handleChange}
                />
                {errors.apellido_paterno && <p className="error-message">{errors.apellido_paterno}</p>}
              </div>
              <div className="input-group">
                <label>Apellido Materno</label>
                <input
                  type="text"
                  name="apellido_materno"
                  value={formData.apellido_materno}
                  onChange={handleChange}
                />
                {errors.apellido_materno && <p className="error-message">{errors.apellido_materno}</p>}
              </div>
              <div className="input-group">
                <label>Correo</label>
                <input
                  type="text"
                  name="correo"
                  value={formData.correo}
                  onChange={handleChange}
                />
                {errors.correo && <p className="error-message">{errors.correo}</p>}
              </div>
              {!isEditing && (
                <div className="input-group">
                  <label>Contraseña</label>
                  <div className="password-container">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="contraseña"
                      value={formData.contraseña}
                      onChange={handleChange}
                    />
                    <span onClick={togglePasswordVisibility} className="toggle-password">
                      <i className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"} icon`}></i>
                    </span>
                    {errors.contraseña && <p className="error-message">{errors.contraseña}</p>}
                  </div>
                </div>
              )}
              {!isEditing && (
                <div className="input-group">
                  <label>Confirmar Contraseña</label>
                  <div className="password-container">
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      name="confirmarContraseña"
                      value={formData.confirmarContraseña}
                      onChange={handleChange}
                    />
                    <span onClick={toggleConfirmPasswordVisibility} className="toggle-password">
                      <i className={`fa ${showConfirmPassword ? "fa-eye-slash" : "fa-eye"} icon`}></i> {/* Usar el nuevo estado */}
                    </span>
                  </div>
                  {errors.confirmarContraseña && <p className="error-message">{errors.confirmarContraseña}</p>}
                </div>
              )}
              <div className="input-group">
                <label>Matricula</label>
                <input
                  type="text"
                  name="matricula"
                  value={formData.matricula}
                  onChange={handleChange}
                />
                {errors.matricula && <p className="error-message">{errors.matricula}</p>}
              </div>
              <div className="input-group">
                <label>Tipo</label>
                <select
                  name="tipo"
                  value={formData.tipo}
                  onChange={handleChange}
                >
                  <option value={0}>Administrador</option>
                  <option value={1}>Alumno</option>
                  <option value={2}>Maestro</option>
                </select>
                {errors.tipo && <p className="error-message">{errors.tipo}</p>}
              </div>

              {errors.error && <p className="error-message">{errors.error}</p>}

              <div className="button-group">

                <button type="submit" className="submit-btn">
                  {isEditing ? "Guardar cambios" : "Agregar usuario"}
                </button>

                <button onClick={() => handleClose()} className="close-btn">
                  Cerrar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/*LISTA DE USUARIOS */}
      {usuarios.length === 0 ? (
        <p>No hay usuarios disponibles</p>
      ) : (
        <table className="usuario-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Nombre</th>
              <th>Apellido Paterno</th>
              <th>Apellido Materno</th>
              <th>Correo</th>
              <th>Matricula</th>
              <th>Tipo</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {usuarios.map((usuario) => (
              <tr key={usuario.id}>
                <td>{usuario.id}</td>
                <td>{usuario.nombre}</td>
                <td>{usuario.apellido_paterno}</td>
                <td>{usuario.apellido_materno}</td>
                <td>{usuario.correo}</td>
                <td>{usuario.matricula}</td>
                <td>{usuario.tipo === 0 ? "Administrador" : usuario.tipo === 1 ? "Alumno" : "Maestro"}</td>
                <td>
                  <button onClick={() => handleEdit(usuario)} className="action-btn">
                    Editar
                  </button>
                  <button onClick={usuario.estatus === 1 ? () => handleDelete(usuario.id, "baja") : () => handleDelete(usuario.id, "alta")} className={usuario.estatus === 1 ? "delete-btn" : "action-btn"}>
                    {usuario.estatus === 1 ? "Desactivar" : "Activar"}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default Usuario;